import CONSTANTS from '@/constants'
import { ISubscriptionsState } from '@/@types'

const state: ISubscriptionsState = {
  currentSubscriptions: [],
  currentInvoices: [],
  passTypes: [],
  manageablePassStates: CONSTANTS.SUBSCRIPTIONS.MANAGEABLE_STATES,
  addTermPricing: {},
  availablePlans: [],
  planDetails: [
    {
      name: 'Learning Paths',
      checked: [
        CONSTANTS.PLANS.MONTHLY,
        CONSTANTS.PLANS.ANNUAL,
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [],
    },
    {
      name: 'Course Labs',
      checked: [
        CONSTANTS.PLANS.MONTHLY,
        CONSTANTS.PLANS.ANNUAL,
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [],
    },
    {
      name: 'Quizzes',
      checked: [
        CONSTANTS.PLANS.MONTHLY,
        CONSTANTS.PLANS.ANNUAL,
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [],
    },
    {
      name: 'Course Files',
      checked: [
        CONSTANTS.PLANS.MONTHLY,
        CONSTANTS.PLANS.ANNUAL,
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [],
    },
    {
      name: 'Learner Usage',
      checked: [
        CONSTANTS.PLANS.MONTHLY,
        CONSTANTS.PLANS.ANNUAL,
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [],
    },
    {
      name: 'Fundamentals Content',
      checked: [
        CONSTANTS.PLANS.MONTHLY,
        CONSTANTS.PLANS.ANNUAL,
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [],
    },
    {
      name: 'Free eJPT and ICCA voucher',
      checked: [],
      unchecked: [],
    },
    {
      name: 'Entire Content Library',
      checked: [
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [CONSTANTS.PLANS.MONTHLY, CONSTANTS.PLANS.ANNUAL],
    },
    {
      name: 'Annual Certification Discount',
      checked: [
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [CONSTANTS.PLANS.MONTHLY, CONSTANTS.PLANS.ANNUAL],
    },
    {
      name: 'Networking Workbooks',
      checked: [
        CONSTANTS.PLANS.PREMIUM,
        CONSTANTS.PLANS.PREMIUM_PLANS.INE_PREMIUM_DEFENSE,
      ],
      unchecked: [CONSTANTS.PLANS.MONTHLY, CONSTANTS.PLANS.ANNUAL],
    },
  ],
  currentPlanComparison: {},
  newPlanCodes: [
    CONSTANTS.PLANS.PREMIUM,
    CONSTANTS.PLANS.ANNUAL,
    CONSTANTS.PLANS.MONTHLY,
    ...Object.values(CONSTANTS.PLANS.BUSINESS),
  ],
  premiumPlanCode: CONSTANTS.PLANS.PREMIUM,
  paymentInfo: {
    last4_of_cc: '',
    account_credit: '$0',
    payment_method: '',
  },
  cancellationFields: {},
  currentPromotionContext: '',
  isUpgradePlanAllowed: false,
  validPlans: [],
  validAddons: [],
  skillDivePlanConsumed: [],
  skillDiveAddHoursPreviewPurchase: 0,
  addHoursPriceLoading: false,
}

export default state
